//External
import React, { useEffect, useState } from "react";
//Internal
import { padLeadingZeros } from "../../utils";

/*******************
  @Purpose : used for category
  @Parameter : { resendOtp, phoneNumber }
  @Author : INIC
  *******************/
function ResenOtp({ resendOtp, phoneNumber, handleClickCount }) {
  const [seconds, setSeconds] = useState(0);

  /*******************
  @Purpose : React Hook used set interval
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  /*******************
  @Purpose : used for resend OTP
  @Parameter : {}
  @Author : INIC
  *******************/
  const resendHandler = () => {
    resendOtp(phoneNumber);
    handleClickCount();
    setSeconds(30);
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <p className="resend-click">
      <span id="timer" className={`${seconds <= 0 && "d-none"}`}>
        00:{padLeadingZeros(seconds, 2)}
      </span>
      {seconds == 0 && (
        <a className="pl-2" onClick={resendHandler}>
          Resend
        </a>
      )}
    </p>
  );
}

export default ResenOtp;
